import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=2e2735b8&scoped=true&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=2e2735b8&lang=scss&scoped=true&"
import style1 from "./Aside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2735b8",
  null
  
)

export default component.exports